import React from 'react';
import GuestbookContent from '../../guestbook/GuestbookContent';

export default function GuestbookApp() {
  return (
    <div className="guestbook-window-app">
      <GuestbookContent />
    </div>
  );
}
